<template>
  <AppLayout>
    <div class="container mt-4">
      <div class="row align-items-center">
        <h2 class="mb-3">{{ this.user_full_name }}</h2>
        <h4 class="mb-3">Zestawienie godzin pracy za okres: {{ formattedMonth }}</h4>
        <div class="row justify-content-end" v-if="isCurrentMonth">
          <div class="col-auto mb-3">
            <div class="form-check form-switch form-switch-success">
              <input class="form-check-input" type="checkbox" role="switch" id="showWeek"
                     style="height:1.5em; width:3em;"
                     v-model="WeekShow"
                     @change="showWeek()">
              <label class="form-check-label" for="showWeek" style="margin: 3px 0 0 10px;">Pokaż tydzień</label>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-12">
            <div class="alert alert-success">
              <h5>Podsumowanie godzin pracy: <strong>{{ calculateTotalWorkHours() }}</strong></h5>
            </div>
          </div>
        </div>

        <div class="row align-items-center mb-3">
          <div class="col-auto d-flex">
            <label for="monthSelect">Miesiąc:</label>
            <select id="monthSelect" v-model="selectedMonth" class="form-select form-select-sm w-100"
                    @change="loadSelectedMonth">
              <option v-for="(month, index) in monthNames" :key="index" :value="index">{{ month }}</option>
            </select>
          </div>

          <div class="col-auto mx-2 d-flex">
            <label for="yearSelect">Rok:</label>
            <select id="yearSelect" v-model="selectedYear" class="form-select form-select-sm w-100"
                    @change="loadSelectedMonth">
              <option v-for="year in yearRange" :key="year" :value="year">{{ year }}</option>
            </select>
          </div>


          <div class="col-auto ms-auto d-flex">
            <a :href="route('worktime-users.generatePdfWorkHours', {year: formattedMonth2.split('-')[0],month: formattedMonth2.split('-')[1]})"
               class="btn btn-outline-info btn-sm me-2">
              <i class="bi bi-file-earmark-pdf"></i>&nbsp;Pobierz zestawienie
            </a>
            <a :href="route('worktime-users.viewPdfWorkHours', {year: formattedMonth2.split('-')[0],month: formattedMonth2.split('-')[1]})"
               rel="noopener noreferrer" target="_blank" class="btn btn-outline-info btn-sm">
              <i class="bi bi-eye"></i>&nbsp;Podgląd zestawienia
            </a>
          </div>
        </div>
      </div>


      <div class="table-responsive">
        <table class="table table-bordered table-hover">
          <thead>
          <tr>
            <th>Data</th>
            <th>Rozpoczęcie</th>
            <th>Zakończenie</th>
            <th>Numer Projektu / Opis</th>
            <th>Akcje</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(day, index) in displayedDays" :key="index"
              :class="{ weekend: isWeekend(day.date), today: isToday(day.date) }">
            <td>{{ day.date.getDate() }}<br>{{ day.name }}</td>
            <td>
              <span v-if="!isEditing[day.date.toDateString()]">{{
                  formatTime(workHoursstart[day.date.toDateString()]) || '--:--'
                }}</span>
              <input v-else type="time" v-model="workHoursstart[day.date.toDateString()]"
                     class="form-control form-control-sm"/>
            </td>
            <td>
              <span v-if="!isEditing[day.date.toDateString()]">{{
                  formatTime(workHoursend[day.date.toDateString()]) || '--:--'
                }}</span>
              <input v-else type="time" v-model="workHoursend[day.date.toDateString()]"
                     class="form-control form-control-sm"/>
            </td>
            <td>
              <div v-if="!isEditing[day.date.toDateString()]">
                <strong>{{ projectnumber[day.date.toDateString()] || '' }}</strong>
                <br>
                <p v-html="formatDescription(descriptions[day.date.toDateString()] || '')"></p>
              </div>
              <div v-if="isEditing[day.date.toDateString()]">
                <input type="text" v-model="projectnumber[day.date.toDateString()]" class="form-control form-control-sm"
                       placeholder="Numer Projektu"/>
                <br>
                <textarea v-model="descriptions[day.date.toDateString()]" class="form-control form-control-sm"
                          placeholder="Opis"></textarea>
              </div>
              <div v-if="isEditing[day.date.toDateString()]">
                <div class="checkbox-info custom-control custom-checkbox d-flex align-items-center">
                  <input
                      type="checkbox"
                      class="custom-control-input"
                      v-model="projectEndet[day.date.toDateString()]"
                      :id="'checkbox-' + day.date.toDateString()"
                      :key="'projectendet-' + day.date.toDateString()"
                  />
                  <label class="custom-control-label ms-2" :for="'checkbox-' + day.date.toDateString()">
                    Projekt zakończony
                  </label>
                </div>
              </div>
              <div v-else>
                <label class="ms-2">
                  <span v-if="projectEndet[day.date.toDateString()] == true"><strong>Projekt zakończony</strong></span>
                  <span v-else></span>
                </label>
              </div>
            </td>

            <td>
              <button v-if="!isWeekend(day.date)" class="btn btn-sm btn-primary"
                      @click="isEditing[day.date.toDateString()] ? saveWorkHours(day.date.toDateString()) : toggleEdit(day.date.toDateString())">
                {{ isEditing[day.date.toDateString()] ? 'Zapisz' : 'Edytuj' }}
              </button>
              <button v-if="!isWeekend(day.date)" class="btn btn-sm btn-danger ms-2"
                      @click="destroyWorkHours(day.date.toDateString())">
                Usuń
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="row">
        <div class="col-md-12 col-lg-12">
          <div class="row">
            <h4 class="me-3 my-0 mb-3">Pliki:</h4>
            <div class="row">
              <ul class="list-group ps-3 me-3 mt-3 mb-3">
                <li class="list-group-item d-flex align-items-center justify-content-between fw-bold bg-light"
                    v-if="localServiceFiles.length > 0">
                  <div class="col-12 col-sm-6 col-md-5">Nazwa pliku</div>
                  <div class="col-12 col-sm-4 col-md-4">Data utworzenia</div>
                  <div class="col-12 col-sm-2 col-md-3 text-end">Opcje</div>
                </li>
                <li v-if="isLoadingFiles" class="list-group-item border-0">
                  <div class="spinner-border spinner-border-reverse align-self-center loader-sm text-secondary">
                    Ładowanie...
                  </div>
                </li>

                <li class="list-group-item d-flex align-items-center justify-content-between flex-wrap" v-else
                    v-for="file in localServiceFiles">
                  <div class="col-12 col-sm-6 col-md-5 text-break">{{ file.name }}</div>
                  <div class="col-12 col-sm-4 col-md-4 text-muted small"><i>{{ formatDate(file.created_at) }}</i></div>
                  <div class="col-12 col-sm-2 col-md-3 text-end mt-2 mt-sm-0">
                    <div class="d-inline-flex">
                      <a class="btn btn-sm btn-outline-info me-2"
                         :href="route('worktime-files.download', [file.id, file.user_id])"
                         download>
                        <i class="bi bi-download me-1"></i>Pobierz
                      </a>
                      <button class="btn btn-sm btn-outline-danger" @click="deleteFile(file)" type="button">
                        <i class="bi bi-trash me-1"></i>Usuń
                      </button>
                    </div>
                  </div>
                </li>
                <li class="list-group-item" v-if="localServiceFiles.length <= 0 && !isLoadingFiles">
                  <i>Brak plików</i>
                </li>
              </ul>
            </div>


            <form @submit.prevent="submitForm">
              <div class="row gap-3">
                <div class="col-12 col-md-6">
                  <label for="attachments">Dodaj pliki:</label>
                  <input type="file" id="attachments" multiple @change="handleFileUpload"
                         class="form-control form-control-sm" ref="fileInput"/>
                  <div v-if="form.attachments.length">
                    <p class="mt-2">Załączone pliki:</p>
                    <ul class="list-group">
                      <li class="list-group-item d-flex justify-content-between align-items-center"
                          v-for="(file, index) in form.attachments" :key="index">
                        {{ file.name }}
                        <button type="button" class="btn btn-sm btn-danger" @click="removeFile(index)">Usuń</button>
                      </li>
                    </ul>
                  </div>
                  <div v-if="form.attachments.length">
                    <template v-if="!isLoading">
                      <button type="submit" class="btn btn-primary mt-3" :disabled="isLoading">
                        {{ isLoading ? 'Wysyłanie...' : 'Dodaj pliki' }}
                      </button>
                    </template>
                  </div>
                </div>
              </div>
              <template v-if="isLoading">
                <div class="mt-4 spinner-border spinner-border-reverse align-self-center loader-sm text-secondary">
                  Ładowanie...
                </div>
              </template>
            </form>


          </div>
        </div>
      </div>


    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import {defineProps, ref} from "vue";
import {useForm, router} from "@inertiajs/vue3";
import route from "../../../../../vendor/tightenco/ziggy/src/js/index.js";
import {Tooltip} from 'bootstrap';
import {isDisabled} from "bootstrap/js/src/util/index.js";
import {usePermission} from "@/composables/resources/js/composables/permissions.js";

export default {
  components: {AppLayout},
  data() {
    const now = new Date();

    const year = now.getFullYear();
    const month = now.getMonth();
    const monthNames = ["Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec", "Lipiec", "Sierpień", "Wrzesień", "Październik", "Listopad", "Grudzień"];
    return {
      isLoading: false,
      workHoursstart: {},
      workHoursend: {},
      projectnumber: {},
      projectEndet: {},
      descriptions: {},
      isEditing: {},
      user_id: {},
      monthNames,
      selectedMonth: month,
      selectedYear: year,
      yearRange: Array.from({length: 10}, (_, i) => year - 5 + i),
      monthDays: this.generateMonthDays(year, month),
      formattedMonth: `${monthNames[month]} ${year}`,
      WeekShow: false,

      isLoadingFiles: false,
      localServiceFiles: [],
      form: {
        attachments: [],
      }
    };
  },
  computed: {
    isCurrentMonth() {
      const now = new Date();
      return now.getFullYear() === this.selectedYear && now.getMonth() === this.selectedMonth;
    },
    displayedDays() {
      if (this.WeekShow && this.isCurrentMonth) {
        const today = new Date();
        const currentDay = today.getDay();

        const startOfWeek = new Date(today);
        startOfWeek.setDate(today.getDate() - (currentDay === 0 ? 6 : currentDay - 1));
        startOfWeek.setHours(0, 0, 0, 0);

        const endOfWeek = new Date(startOfWeek);
        endOfWeek.setDate(startOfWeek.getDate() + 6);
        endOfWeek.setHours(23, 59, 59, 999);

        return this.monthDays.filter(day => {
          const dayDate = new Date(day.date);
          return dayDate >= startOfWeek && dayDate <= endOfWeek;
        });
      }


      return this.monthDays;
    },
    formattedMonth2() {
      return `${this.selectedYear}-${String(this.selectedMonth + 1).padStart(2, '0')}`;
    }
  },
  mounted() {
    this.user_id = this.$page.props.user_id;
    this.user_full_name = this.$page.props.user_full_name;
    this.fetchWorkHours();
    this.fetchFiles();

  },


  methods: {
    toggleCheckbox(day) {
    },
    showWeek() {
    },

    formatDate(dateString) {
      if (!dateString) return '';
      let localDate = new Date(dateString);
      const timezoneOffset = localDate.getTimezoneOffset();
      localDate.setMinutes(localDate.getMinutes() - timezoneOffset);
      return localDate.toISOString().split('T')[0];
    },
    parseDateForSaving(dateString) {
      if (!dateString) return null;
      let localDate = new Date(dateString);
      localDate.setHours(12, 0, 0, 0);
      return localDate.toISOString();
    },
    formatDescription(text) {
      return text.replace(/\n/g, '<br>');
    },
    formatTime(time) {
      if (!time) return '';
      const [hours, minutes] = time.split(':');
      return `${hours}:${minutes}`;
    },
    removeFile(index) {
      this.form.attachments.splice(index, 1);
    },
    fetchFiles() {
      this.isLoadingFiles = true;
      axios.get(route('worktime-files.officeFilesIndex'), {
        params: {
          year: this.selectedYear,
          month: this.selectedMonth + 1,
          user_id: this.user_id,
        }
      }).then((response) => {
        this.localServiceFiles = response.data;
      }).finally(() => {
        this.isLoadingFiles = false;
      });
    },
    handleFileUpload(event) {
      const files = event.target.files;
      this.form.attachments = [...files];
    },
    submitForm() {
      let formData = new FormData();

      formData.append('user_id', this.user_id);

      this.form.attachments.forEach(file => {
        formData.append('attachments[]', file);
      });

      formData.append('okres', this.formattedMonth2);
      this.isLoadingFiles = true;

      axios.post(route('worktime-files.officeFilesStore'), formData, {
        headers: {'Content-Type': 'multipart/form-data'}
      }).then((response) => {
        this.fetchFiles();
        this.form.attachments = [];
        this.$refs.fileInput.value = "";
      }).finally(() => {
        this.isLoadingFiles = false;
      });
    },
    deleteFile(file) {
      if (confirm('Czy na pewno chcesz usunąć plik?')) {
        axios.delete(route('worktime-files.destroy', file.id)).then(() => {
          this.fetchFiles();
        });
      }
    },

    calculateTotalWorkHours() {
      let totalMinutes = 0;

      for (let day in this.workHoursstart) {
        const start = this.workHoursstart[day];
        const end = this.workHoursend[day];

        if (start && end) {
          const startParts = start.split(':');
          const endParts = end.split(':');

          const startDate = new Date();
          startDate.setHours(parseInt(startParts[0]), parseInt(startParts[1]));

          const endDate = new Date();
          endDate.setHours(parseInt(endParts[0]), parseInt(endParts[1]));

          totalMinutes += (endDate - startDate) / 60000;
        }
      }

      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      return `${hours}h ${minutes}m`;
    },

    async destroyWorkHours(dateStr) {
      if (!confirm("Czy na pewno chcesz usunąć ten wpis?")) return;

      const payload = {
        user_id: this.user_id,
        date: this.formatDate(dateStr),
      };

      try {
        await axios.delete(route('worktime.office.destroy'), {data: payload});

        delete this.workHoursstart[dateStr];
        delete this.workHoursend[dateStr];
        delete this.projectnumber[dateStr];
        delete this.projectEndet[dateStr];
        delete this.descriptions[dateStr];

        this.showToast('success', 'Usunięto', 'Wpis został pomyślnie usunięty.');
      } catch (error) {
        this.showToast('error', 'Błąd', 'Nie udało się usunąć wpisu.');
      }
    },


    async fetchWorkHours() {
      try {

        const response = await axios.get(route('worktime.office.show', {
          year: this.selectedYear,
          month: this.selectedMonth + 1,
          id: this.user_id
        }));

        const workHours = response.data;

        this.workHoursstart = {};
        this.workHoursend = {};
        this.projectnumber = {};
        this.projectEndet = {};
        this.descriptions = {};
        this.files = {};

        workHours.forEach(entry => {
          const dateKey = new Date(entry.date).toDateString();

          this.workHoursstart[dateKey] = entry.start;
          this.workHoursend[dateKey] = entry.end;
          this.projectnumber[dateKey] = entry.project_number;
          this.projectEndet[dateKey] = entry.project_endet === 1;
          this.descriptions[dateKey] = entry.description;

          if (entry.files && entry.files.length) {
            this.files[dateKey] = entry.files;
          }
        });
      } catch (error) {
      }
    },

    async saveWorkHours(dateStr) {
      const payload = {
        user_id: this.user_id,
        date: this.formatDate(dateStr),
        start_time: this.workHoursstart[dateStr] || null,
        end_time: this.workHoursend[dateStr] || null,
        project_number: this.projectnumber[dateStr] || '',
        project_endet: this.projectEndet[dateStr] ? '1' : '0',
        description: this.descriptions[dateStr] || ''
      };

      try {
        await axios.post(route('worktime.office.officeStore'), payload)
            .then(async () => {
              await this.fetchWorkHours();
              Toast.fire({
                icon: 'success',
                title: 'Zapisano zmiany',
                html: '<strong>Godziny pracy zostały zapisane.</strong>',
                timer: 1500,
                timerProgressBar: true,
              });
            });

        this.toggleEdit(dateStr);
      } catch (error) {
        Toast.fire({
          icon: 'error',
          title: 'Błąd zapisu',
          html: '<strong>Nie udało się zapisać zmian.</strong><br>Spróbuj ponownie później.',
        });
      }
    },


    generateMonthDays(year, month) {
      const days = [];
      const daysInMonth = new Date(year, month + 1, 0).getDate();
      const dayNames = ["Nd", "Pon", "Wt", "Śro", "Czw", "Pią", "Sob"];

      for (let day = 1; day <= daysInMonth; day++) {
        const date = new Date(year, month, day);
        days.push({date, name: dayNames[date.getDay()]});
      }
      return days;
    },

    isWeekend(date) {
      return date.getDay() === 0 || date.getDay() === 6;
    },

    isToday(date) {
      const today = new Date();
      return today.toDateString() === date.toDateString();
    },

    loadSelectedMonth() {
      this.workHoursstart = {};
      this.workHoursend = {};
      this.projectnumber = {};
      this.projectEndet = {};

      this.descriptions = {};

      this.monthDays = this.generateMonthDays(this.selectedYear, this.selectedMonth);
      this.formattedMonth = `${this.monthNames[this.selectedMonth]} ${this.selectedYear}`;

      this.fetchWorkHours();

      this.fetchFiles();
    },

    toggleEdit(dateStr) {
      this.isEditing[dateStr] = !this.isEditing[dateStr];
    },

    showToast(icon, title, message) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: icon,
        title: title,
        html: message,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: 1500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    }
  }
};
</script>


<style scoped>
.container {
  max-width: 100%;
  margin: auto;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table-responsive {
  overflow-x: auto;
}

.weekend td {
  background-color: #d0f3a2 !important;
}

.today td {
  background-color: #82c6f2 !important;
}

.today tr {
  border: 1px solid #676866;
}

th, td {
  padding: 8px;
  border: 1px solid #ddd;
  text-align: center;
}

.btn-sm {
  padding: 4px 8px;
  font-size: 12px;
}

.form-select-sm {
  width: 100px;
}
</style>
